/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { MediaUiAPlayPauseIcon16Light } from './MediaUiAPlayPauseIcon16Light';
import { MediaUiAPlayPauseIcon16Regular } from './MediaUiAPlayPauseIcon16Regular';
import { MediaUiAPlayPauseIcon16Solid } from './MediaUiAPlayPauseIcon16Solid';
import { MediaUiAPlayPauseIcon20Light } from './MediaUiAPlayPauseIcon20Light';
import { MediaUiAPlayPauseIcon20Regular } from './MediaUiAPlayPauseIcon20Regular';
import { MediaUiAPlayPauseIcon20Solid } from './MediaUiAPlayPauseIcon20Solid';
import { MediaUiAPlayPauseIcon24Regular } from './MediaUiAPlayPauseIcon24Regular';
import { MediaUiAPlayPauseIcon24Solid } from './MediaUiAPlayPauseIcon24Solid';
import { MediaUiAPlayPauseIcon32Regular } from './MediaUiAPlayPauseIcon32Regular';
import { MediaUiAPlayPauseIcon64Regular } from './MediaUiAPlayPauseIcon64Regular';
var sizes = {
    16: {
        light: MediaUiAPlayPauseIcon16Light,
        regular: MediaUiAPlayPauseIcon16Regular,
        solid: MediaUiAPlayPauseIcon16Solid,
    },
    20: {
        light: MediaUiAPlayPauseIcon20Light,
        regular: MediaUiAPlayPauseIcon20Regular,
        solid: MediaUiAPlayPauseIcon20Solid,
    },
    24: {
        regular: MediaUiAPlayPauseIcon24Regular,
        solid: MediaUiAPlayPauseIcon24Solid,
    },
    32: {
        regular: MediaUiAPlayPauseIcon32Regular,
    },
    64: {
        regular: MediaUiAPlayPauseIcon64Regular,
    },
};
export var MediaUiAPlayPauseIcon = forwardRef('MediaUiAPlayPauseIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
